import { render, staticRenderFns } from "./match_day.vue?vue&type=template&id=0d47aa02"
import script from "./match_day.vue?vue&type=script&lang=js"
export * from "./match_day.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports